export const shortenString = (
  inputString: string | undefined,
  maxLength: number,
  ellipsis = '...',
  position: 'start' | 'middle' | 'end' = 'middle'
): string => {
  if (!inputString) {
    return ''
  }

  if (inputString.length <= maxLength) {
    return inputString
  }

  if (position === 'start') {
    return (
      ellipsis +
      inputString.substring(inputString.length - maxLength + ellipsis.length)
    )
  }
  if (position === 'end') {
    return inputString.substring(0, maxLength - ellipsis.length) + ellipsis
  }

  const halfLength = Math.floor((maxLength - ellipsis.length) / 2)
  return (
    inputString.substring(0, halfLength) +
    ellipsis +
    inputString.substring(inputString.length - halfLength)
  )
}

export const upperCaseFirst = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
export function randomString(length: number): string {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}

export const wrapLongWords = (text: string, max = 20) =>
  text.replace(/\S+/g, (w) =>
    w.length > max ? `<span class="break">${w}</span>` : w
  )
